module.exports = __webpack_public_path__ + "static/icon11-6471519d3b77b5e613fc32a1852923eb.png";